// tslint:disable
export enum ContactDatePreferenceType {
    /**
     * @description UNKNOWN
     */
    UNKNOWN = 0,
    /**
     * @description DAY
     */
    DAY = 1,
    /**
     * @description BETWEEN DATES
     */
    BETWEENDATES = 2,
    /**
     * @description HOLIDAY
     */
    HOLIDAY = 3,
    /**
     * @description WEEKENDS
     */
    WEEKENDS = 4,
    /**
     * @description WEEK DAYS
     */
    WEEKDAYS = 5,
}
